import { render, staticRenderFns } from "./EditSubjectAreaModal.vue?vue&type=template&id=6774f536&lang=pug&"
import script from "./EditSubjectAreaModal.vue?vue&type=script&lang=js&"
export * from "./EditSubjectAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports